"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lockupKind = exports.LockupKindEnum = void 0;
var LockupKindEnum;
(function (LockupKindEnum) {
    LockupKindEnum["None"] = "none";
    LockupKindEnum["Daily"] = "daily";
    LockupKindEnum["Monthly"] = "monthly";
    LockupKindEnum["Cliff"] = "cliff";
    LockupKindEnum["Constant"] = "constant";
})(LockupKindEnum || (exports.LockupKindEnum = LockupKindEnum = {}));
function lockupKind(lockupKind) {
    if (typeof lockupKind !== 'object' || Object.keys(lockupKind).length !== 1) {
        throw new Error('Cannot decode lockup kind: ' + lockupKind);
    }
    switch (Object.keys(lockupKind)[0]) {
        case 'none':
            return LockupKindEnum.None;
        case 'daily':
            return LockupKindEnum.Daily;
        case 'monthly':
            return LockupKindEnum.Monthly;
        case 'cliff':
            return LockupKindEnum.Cliff;
        case 'constant':
            return LockupKindEnum.Constant;
        default:
            throw new Error('Cannot decode lockup kind: ' + lockupKind);
    }
}
exports.lockupKind = lockupKind;
//# sourceMappingURL=enums.js.map